var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPhone(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.25C2.5875 2.25 2.25 2.5875 2.25 3V21C2.25 21.4125 2.5875 21.75 3 21.75H13.5C13.9125 21.75 14.25 21.4125 14.25 21V3C14.25 2.5875 13.9125 2.25 13.5 2.25H3ZM0 3C0 1.34531 1.34531 0 3 0H13.5C15.1547 0 16.5 1.34531 16.5 3V21C16.5 22.6547 15.1547 24 13.5 24H3C1.34531 24 0 22.6547 0 21V3ZM8.25 18.375C8.54837 18.375 8.83452 18.4935 9.0455 18.7045C9.25647 18.9155 9.375 19.2016 9.375 19.5C9.375 19.7984 9.25647 20.0845 9.0455 20.2955C8.83452 20.5065 8.54837 20.625 8.25 20.625C7.95163 20.625 7.66548 20.5065 7.4545 20.2955C7.24353 20.0845 7.125 19.7984 7.125 19.5C7.125 19.2016 7.24353 18.9155 7.4545 18.7045C7.66548 18.4935 7.95163 18.375 8.25 18.375Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic-phone.c71d9660b5927fadca7a5d3c6623a61a.svg";
export { ForwardRef as ReactComponent };